import { withLocalState } from 'pyradux';

import OffersContainer from './Offers.container';
import reducer from './Offers.reducer';
import OffersSagas from './Offers.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'offers',
  sagas: [OffersSagas],
};

export default withLocalState(withLocalStateOptions, OffersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/index.js